export default "__VITE_PUBLIC_ASSET__47a2ffe1__"